import React, { useState, useEffect } from 'react';
import ErrorMsgField from '../../../components/ErrorMsgField';
import Select from 'react-select';
import PropTypes from 'prop-types';
/* utils */
import { customStyle, customThemes } from '../../../utils/select';
import sortable from '../../../utils/sortable';

function Responsibles (props) {
  const { clients, data, setData } = props;
  const INITIAL_CLIENT = { _id: '', name: '' };
  const firstOption = {
    value: '',
    sortValue: '',
    label: 'Pesquisar'
  };
  const customFilter = (option, searchText) => {
    setSearchText(searchText);
    return !!option.data.label.toLowerCase().includes(searchText.toLowerCase());
  };
  const [searchText, setSearchText] = useState('');
  const [searchClient, setSearchClient] = useState('');
  const [client, setClient] = useState(INITIAL_CLIENT);
  const [clientOptions, setClientOptions] = useState([firstOption]);

  useEffect(() => {
    if (clients.length) {
      const options = clients
        .map(client => ({
          clientId: client._id,
          value: client.cpf ? client.cpf : client.cnpj,
          label: `${client.name} - ${client.cpf ? client.cpf : client.cnpj}`,
          sortValue: client.name
        }))
        .sort(sortable);
      options.unshift(firstOption);
      setClientOptions([...options]);
    }
  }, [clients, setClientOptions]);

  const handleChangeSearchClient = evt => {
    const { value } = evt;
    setSearchClient(value);
    const client = clients.find(
      client => client.cpf === value || client.cnpj === value
    );
    if (client) {
      setClient(client);
    } else {
      setClient(INITIAL_CLIENT);
    }
  };

  const handleClickAddResponsibles = () => {
    const { responsibles } = data;
    if (client._id && !responsibles.includes(client._id)) {
      responsibles.push(client._id);
      setData({ ...data, responsibles });
      setSearchClient('');
      setClient(INITIAL_CLIENT);
    }
  };

  const handleClickRemoveResponsibles = id => {
    const responsibles = data.responsibles.filter(clientId => clientId !== id);
    setData({ ...data, responsibles });
  };

  return (
    <div className="row">
      <div className="col-sm-4">
        <div className="form-group">
          <div className="form-group form-inline mb-0">
            <label
              className="col-sm-12 d-inline p-0 mb-2"
              htmlFor="searchClient"
            >
              Nome, CPF ou CNPJ do Responsável
            </label>
            <Select
              className="col p-0"
              name="searchClient"
              onChange={handleChangeSearchClient}
              defaultValue={clientOptions[0]}
              value={clientOptions.find(
                client => client.value === searchClient
              )}
              options={clientOptions.filter(
                opt =>
                  (!data.responsibles.includes(opt.clientId) &&
                    opt.value !== searchText &&
                    searchText.length >= 4) ||
                  opt.value === ''
              )}
              isSearchable={true}
              theme={customThemes}
              styles={{
                ...customStyle,
                indicatorsContainer: () => ({ display: 'none' })
              }}
              filterOption={customFilter}
              noOptionsMessage={() => 'Nenhum registro até o momento'}
            />
          </div>
        </div>
      </div>
      <div className="col-sm-8">
        <div className="form-group form-inline mb-0">
          <label htmlFor="nameClient" className="w-100 d-inline-block mb-2">
            Nome do Responsável
          </label>
          <input
            type="text"
            id="nameClient"
            name="nameClient"
            className="form-control w-75"
            value={client.name}
            disabled={true}
          />
          <button
            type="button"
            className="btn btn-info rounded-0 w-25"
            title="Adicinar responsável na lista"
            disabled={!(client.name && !data.responsibles.includes(client._id))}
            onClick={handleClickAddResponsibles}
          >
            <i className="fa fa-plus" />
          </button>
        </div>
        {data.responsibles.includes(client._id) && (
          <ErrorMsgField
            type="repeat"
            msg="Cliente pesquisado está na lista de membros"
          />
        )}
      </div>
      <div className="col-sm-12">
        <div className="form-group mt-2">
          <label>Lista de Responsáveis</label>
          {data.responsibles.length ? (
            data.responsibles.map((clientId, i) => {
              const client = clients.find(client => client._id === clientId);
              return (
                <div key={i}>
                  <span>
                    {client
                      ? `${client.name} - ${
                          client.cpf ? client.cpf : client.cnpj
                        }`
                      : 'Carregando...'}
                  </span>
                  {client && (
                    <button
                      className="btn btn-danger btn-sm ml-2 mb-1"
                      onClick={() => handleClickRemoveResponsibles(client._id)}
                    >
                      <i className="fa fa-trash" />
                    </button>
                  )}
                </div>
              );
            })
          ) : (
            <div>
              <span className="text-danger">
                * Nenhum responsável foi adicionado
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

Responsibles.propTypes = {
  clients: PropTypes.array,
  data: PropTypes.object,
  setData: PropTypes.func
};

export default Responsibles;
